module.exports = __webpack_public_path__ + "static/media/bubbleJacket.42a24887.jpg";